// Native
import { useState } from "react"
import { Box, Button, DialogBody, Separator, Stack, Text, useDisclosure } from "@chakra-ui/react"
import { useQueryClient } from "@tanstack/react-query"
import moment from "moment"

// Custom
import { Parts, UI } from "components"
import { API, Styles, toaster } from "config"
import useUser from "hooks/useUser"

export default function Request({ ...props }){

    const queryClient = useQueryClient()
    const user = useUser() 
    const career = user.data?.consultant?.career?.current_career
    const style = Styles.pin(career?.id)
    const is_enabled  = moment().format('DD') != '01' && career?.id >= 2
    const authenticate = useDisclosure()
    const [ loading, setLoading ] = useState(false)

    const handleAnticipate = async () => {
        if(!is_enabled) return
        setLoading(true)

        try{
            await API.post('/anticipations', null, { timeout: 100000 })
            toaster.create({ title: 'Antecipação realizada', type: 'success' })
            queryClient.invalidateQueries('user')
            queryClient.invalidateQueries('bonus-report')
            queryClient.invalidateQueries('points-report')
            props.onClose()
        }catch(err){
            toaster.create({ title: 'Não foi possível antecipar', description: err?.response?.data?.message, type: 'warning' })
        }

        setLoading(false)
    }

    return(
    <>
    <Parts.Dialog.SecurityCode.Check {...authenticate} onSuccess={handleAnticipate} />
    <UI.Dialog title="Antecipar ciclo" size="sm" loading={loading} {...props}>
        <DialogBody>
            <Stack gap={4}>

                <Text>A antecipação de ciclo é um benefício exclusivo da Bonífica, permite que você tenha dinheiro para alavancar sua rede, mas deve ser usada de forma estratégica, confira detalhes:</Text>
            
                <Box as="ul" listStyle="square" pl={4} fontSize="xs" color="GrayText">
                    <Box as="li" _marker={{ color: "orange" }}>Ao realizar uma antecipação todos os pontos acima da VME serão coletados.</Box>
                    <Box as="li" _marker={{ color: "orange" }}>Você voltará ao <b>PIN CONSULTOR</b>.</Box>
                    <Box as="li" _marker={{ color: "orange" }}>O Bônus referente ao PIN que foi solicitado estará disponível imediatamente em seu saldo.</Box>
                    <Box as="li" _marker={{ color: "orange" }}>Os pontos restantes dentro da VME após antecipação de PIN's BASE, permanecerão disponíveis para requalificação.</Box>
                </Box>

                <Separator />

                <Button disabled={!is_enabled} colorPalette={style.colorPalette} onClick={authenticate.onOpen} loading={loading} loadingText="Antecipando ciclo..."><UI.Icon name="anticipation" /> Antecipar {career?.title}</Button>
            </Stack>
        </DialogBody>
    </UI.Dialog>
    </>
    )
}